export const nextDayModal = (shippingType, globalShippingMode) => {
  const typeOfShipping = shippingType;
  const thisDate = new Date();
  const getDate = thisDate.getDate();
  const month = thisDate.getMonth() + 1;
  const useDate = month + '/' + getDate;
  const day = thisDate.getDay();
  let dayToDisplay;
  let holiday;

  //FedEx Closed
  let holidayDates = [];
  holidayDates.push('1/1');   //Jan 1
  holidayDates.push('4/21');  //Easter
  holidayDates.push('5/27');  //Memorial Day
  holidayDates.push('7/4');   //July 4
  holidayDates.push('9/2');   //Labor Day
  holidayDates.push('11/28'); //Thanksgiving
  holidayDates.push('12/25'); //Christmas
  if (holidayDates.indexOf(useDate) > -1) {
    holiday = true;
  }

  const calcDay = {
    0: {
      expeditedMorning: 'Wednesday',
      expeditedAfterNoon: 'Wednesday',
      nextDayMorning: 'Tuesday',
      nextDayAfterNoon: 'Tuesday'
    },
    1: {
      expeditedMorning: 'Wednesday',
      expeditedAfterNoon: 'Thursday',
      nextDayMorning: 'Tuesday',
      nextDayAfterNoon: 'Wednesday'
    },
    2: {
      expeditedMorning: 'Thursday',
      expeditedAfterNoon: 'Friday',
      nextDayMorning: 'Wednesday',
      nextDayAfterNoon: 'Thursday'
    },
    3: {
      expeditedMorning: 'Friday',
      expeditedAfterNoon: 'Monday',
      nextDayMorning: 'Thursday',
      nextDayAfterNoon: 'Friday'
    },
    4: {
      expeditedMorning: 'Monday',
      expeditedAfterNoon: 'Tuesday',
      nextDayMorning: 'Friday',
      nextDayAfterNoon: 'Monday'
    },
    5: {
      expeditedMorning: 'Tuesday',
      expeditedAfterNoon: 'Wednesday',
      nextDayMorning: 'Monday',
      nextDayAfterNoon: 'Tuesday'
    },
    6: {
      expeditedMorning: 'Wednesday',
      expeditedAfterNoon: 'Wednesday',
      nextDayMorning: 'Tuesday',
      nextDayAfterNoon: 'Tuesday'
    }
  };

  if (typeOfShipping == 'expeditedMorning' && !holiday) {
    dayToDisplay = calcDay[day].expeditedMorning;
  } else if (typeOfShipping == 'expeditedAfterNoon' && !holiday) {
    dayToDisplay = calcDay[day].expeditedAfterNoon;
  } else if (typeOfShipping == 'nextDayMorning' && !holiday) {
    dayToDisplay = calcDay[day].nextDayMorning;
  } else if (typeOfShipping == 'nextDayAfterNoon' && !holiday) {
    dayToDisplay = calcDay[day].nextDayAfterNoon;
  } else if (holiday && globalShippingMode == '10003') {
    dayToDisplay = calcDay[day + 1].nextDayMorning;
  } else if (holiday && globalShippingMode == '10002') {
    dayToDisplay = calcDay[day + 1].expeditedMorning;
  }

  const displayNextDayModal = (html) => {
    $('body').append(html);
    if ($('.next-day-modal').length > 0) {
      $('.next-day-modal h5').focus();
    }
  };

  const closeNextDayModal = () => {
		$('.closeNextDayBtn, .next-day-backdrop').on('click', function () {
			$('.next-day-modal').remove();
			$('.next-day-backdrop').remove();

			var modalOpenInputs = $('#expedited-delivery, #next-day');
			for (var step = 0; step < modalOpenInputs.length; step++) {
				var inputToCheck = modalOpenInputs[step];
				if ($(inputToCheck).is(':checked')) {
					$(inputToCheck).parent().trigger('focus');
				}
			}
		});
	};

  let html = `<div class="next-day-modal" aria-modal="true" role="dialog" aria-label="Shipping Options Delivery Times">
                    <h5 tabindex="-1">Your order is expected to arrive</h5>
                    <h1>${dayToDisplay}</h1>
                    <br>
                    <p>Expedited or Next Day orders placed after 12:00 p.m. (noon) Central Time will be shipped the following business day <b>excluding holidays</b>.</p>
                    <p>You can expect delivery in two (2) business days for Expedited service and one (1) business day for Next Day service after shipping.</p>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary closeNextDayBtn">Continue</button>       
                    </div>
                </div>
                <div class="next-day-backdrop"></div>`

  displayNextDayModal(html);
  closeNextDayModal();
};
